import { render } from "./CommitteeSlider.vue?vue&type=template&id=4043db9c"
import script from "./CommitteeSlider.vue?vue&type=script&lang=js"
export * from "./CommitteeSlider.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/ktl/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__